// Keep in sync with benchling/dev_platform/constants.py
export enum AvailabilityToShow {
  LA = 'la',
  GA = 'ga',
  NOT_AVAILABLE = 'not-available',
}

export enum AllowedVersions {
  V2_ALPHA = 'v2-alpha',
  V2_BETA = 'v2-beta',
  V2 = 'v2',
  V3_DRAFT = 'v3-draft',
  V3 = 'v3',
  // Local-only developer playground; only rendered when DEPLOY_ENVIRONMENT === 'development'.
  V3_INTERNAL = 'v3-internal',
}
